import InputField from '../../inputs/inputField'
import CalendarInput from '../../inputs/calendarInput'

export default function MediaCitationForm({
	formData,
	setFormData,
	requiredFields,
	errorFields,
}: {
	formData: any
	setFormData: (data: any) => void
	requiredFields: any[]
	errorFields: any[]
}) {
	const handleDataChange = (name: string, value: string) => {
		let newData = { ...formData }
		newData[name] = value
		setFormData(newData)
	}

	return (
		<div className="flex w-full flex-col gap-y-2">
			<InputField
				name="title"
				type="text"
				placeholder="Enter Title"
				containerWidth="w-full"
				value={formData.title}
				displayRequired={requiredFields.find(field => field.slug == 'title')}
				onChange={e => {
					handleDataChange('title', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'title',
				)}
			/>
			<InputField
				name="url"
				type="text"
				placeholder="https://"
				containerWidth="w-full"
				value={formData.url}
				displayRequired={requiredFields.find(field => field.slug == 'url')}
				helper={'Enter Full URL (https://...)'}
				onChange={e => {
					handleDataChange('url', e.target.value)
				}}
				isError={errorFields.find(requiredField => requiredField.slug == 'url')}
			/>
			<CalendarInput
				name="Publishing Date"
				containerWidth="w-full"
				value={formData.date}
				displayRequired={requiredFields.find(field => field.slug == 'date')}
				onChange={e => {
					handleDataChange('date', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'date',
				)}
			/>
			<div className="flex flex-row gap-x-4">
				<div className="w-1/2">
					<InputField
						name="publisher"
						type="text"
						placeholder="Media Citation Publisher"
						containerWidth="w-full"
						value={formData.publisher}
						displayRequired={requiredFields.find(
							field => field.slug == 'publisher',
						)}
						onChange={e => {
							handleDataChange('publisher', e.target.value)
						}}
						isError={errorFields.find(
							requiredField => requiredField.slug == 'publisher',
						)}
					/>
				</div>
				<div className="w-1/2">
					<InputField
						name="author"
						type="text"
						placeholder="Media Citation Author"
						containerWidth="w-full"
						value={formData.author}
						displayRequired={requiredFields.find(
							field => field.slug == 'author',
						)}
						onChange={e => {
							handleDataChange('author', e.target.value)
						}}
						isError={errorFields.find(
							requiredField => requiredField.slug == 'author',
						)}
					/>
				</div>
			</div>
			<InputField
				name="description"
				lines={4}
				placeholder="Add a description for this media citation"
				containerWidth="w-full"
				additionalClasses="h-32"
				value={formData.description}
				displayRequired={requiredFields.find(
					field => field.slug == 'description',
				)}
				onChange={e => {
					handleDataChange('description', e.target.value)
				}}
				isError={errorFields.find(
					requiredField => requiredField.slug == 'description',
				)}
			/>
		</div>
	)
}
